import React, { useContext } from "react";
import TemplateElementWarningsService from "packs/services/convertflow/template_element_warnings_service";
import { VariantContextData } from "../variants/VariantBuilderContext";
import VariantBuilderSetting from "../variants/VariantBuilderSetting";
import ConditionsBuilder from "../conditions/ConditionsBuilder";
import SchedulerEmbedSettings from "../elements/SchedulerEmbedSettings";
import { schedulerTypeLabel } from "../../utils/schedulerTypes";
import SidePanelLabeledSection from "../shared/SidePanelLabeledSection";

const SchedulerRecommendationSettings = (props) => {
  const [contextData, builder] = useContext(VariantContextData);

  let website = contextData.objects.website;
  let cta = contextData.objects.cta;
  let variant = contextData.objects.variant;
  let scheduler_recommendation = props.scheduler_recommendation;
  let element = props.element;
  let existing_conditions = Object.values(variant.conditions).filter(
    (condition) =>
      condition.contactable_type == "SchedulerRecommendation" &&
      condition.contactable_id == scheduler_recommendation.id &&
      condition.toBeDeleted !== true
  );
  let warningVisible = existing_conditions.length == 0;

  const schedulerType =
    scheduler_recommendation.options["scheduler_type"] || "calendly";
  const schedulerUrl = scheduler_recommendation.options["scheduler-url"] || "";
  let object_info = schedulerTypeLabel(schedulerType);
  if (schedulerUrl) {
    object_info += ` — ${schedulerUrl}`;
  }

  return (
    <React.Fragment>
      <VariantBuilderSetting
        object={scheduler_recommendation}
        setting_name="[modal_trigger]"
        setting_type="item_v2"
        object_type="scheduler_recommendations"
        object_id={scheduler_recommendation.id}
        title={
          scheduler_recommendation.options["label"]
            ? scheduler_recommendation.options["label"]
            : object_info
        }
        modalTitle={`Scheduler Recommendation - ${
          scheduler_recommendation.options["label"]
            ? scheduler_recommendation.options["label"]
            : object_info
        }`}
        style={{ margin: "4px 0px" }}
        label_max_length={25}
        label_hover_max_length={14}
        panel_type="modal"
        side_panel={true}
        draggable="false"
        warning={
          warningVisible
            ? "Scheduler filter is incomplete"
            : TemplateElementWarningsService.getSchedulerRecommendationRollupWarning(
                scheduler_recommendation,
                variant
              )
        }
        warningBorder={false}
        label_icon="fas fa-calendar"
        duplicate_payload={{
          element_id: element.id,
        }}
      >
        <VariantBuilderSetting
          object={scheduler_recommendation}
          setting_name="[options][label]"
          setting_type="text"
          object_type="scheduler_recommendations"
          object_id={scheduler_recommendation.id}
          label={`Label this scheduler recommendation`}
          value={
            scheduler_recommendation.options["label"]
              ? scheduler_recommendation.options["label"]
              : ""
          }
          placeholder="Write label here"
          update_on_input_end={true}
        />

        <SidePanelLabeledSection label="If">
          <ConditionsBuilder
            cta={cta}
            variant={variant}
            website={website}
            contactable_type="SchedulerRecommendation"
            contactable_id={scheduler_recommendation.id}
            dark_mode={contextData.dark_mode}
            builder={true}
            hide_delete_button={true}
          />
        </SidePanelLabeledSection>

        <SidePanelLabeledSection label="Then">
          <SchedulerEmbedSettings
            object={scheduler_recommendation}
            object_type="scheduler_recommendations"
            object_id={scheduler_recommendation.id}
          />
        </SidePanelLabeledSection>
      </VariantBuilderSetting>
    </React.Fragment>
  );
};

export default SchedulerRecommendationSettings;
